import React from 'react';
import {
  faUsers,
  faCalendarCheck,
  faCalendarDay,
  faChartLine
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import QuickActions from '../components/QuickActions';
import QuickPacienteAccess from '../components/QuickPacienteAccess';
import RecentConsultas from '../components/RecentConsultas';
import StatsCard from '../components/StatsCard';
import useDashboard from '../hooks/useDashboard';
import PageHeader from '../components/PageHeader';
import { useAuth } from '../hooks/useAuth';

const DashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const { currentOrganization } = useAuth();
  const { stats, recentConsultas, loading, error } = useDashboard();

  const handleConsultasTodayClick = () => {
    const today = new Date().toISOString().split('T')[0];
    navigate(`/consultas?filter=current_week&startDate=${today}&endDate=${today}`);
  };

  const handleConsultasThisMonthClick = () => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
      .toISOString()
      .split('T')[0];
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0)
      .toISOString()
      .split('T')[0];
    navigate(
      `/consultas?filter=current_month&startDate=${firstDayOfMonth}&endDate=${lastDayOfMonth}`
    );
  };

  if (error) {
    return (
      <main className="w-full flex-grow p-6">
        <div className="text-center py-12">
          <p className="text-red-600">Erro ao carregar dados: {error}</p>
        </div>
      </main>
    );
  }

  const title = [currentOrganization?.name, currentOrganization?.slogan]
    .filter(Boolean)
    .join(' | ');

  return (
    <main className="w-full flex-grow p-6">
      <div className="mx-auto">
        <PageHeader title="Dashboard" subtitle={title} />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <StatsCard
            title="Total Pacientes"
            value={loading ? '...' : stats.totalPacientes}
            icon={faUsers}
            color="blue"
          />
          <StatsCard
            title="Consultas Hoje"
            value={loading ? '...' : stats.consultasToday}
            icon={faCalendarDay}
            color="green"
            onClick={handleConsultasTodayClick}
            clickable
          />
          <StatsCard
            title="Consultas Este Mês"
            value={loading ? '...' : stats.consultasThisMonth}
            icon={faCalendarCheck}
            color="purple"
            onClick={handleConsultasThisMonthClick}
            clickable
          />
          <StatsCard
            title="Total Consultas"
            value={loading ? '...' : stats.totalConsultas}
            icon={faChartLine}
            color="orange"
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
          <div className="lg:col-span-2">
            <RecentConsultas consultas={recentConsultas} loading={loading} />
          </div>
          <div>
            <QuickPacienteAccess />
          </div>
        </div>

        <div className="grid grid-cols-1">
          <QuickActions />
        </div>
      </div>
    </main>
  );
};

export default DashboardPage;
